import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Building an Interpreter",
description: "Learn how to build an interpreter in Freon using the Computer Aided Learning DSL. This example walks through implementing literal and binary expression evaluation functions in TypeScript.",
tags: [ "Freon", "interpreter", "EducationInterpreter", "evaluation", "AST", "RtNumber", "RtFraction", "RtBoolean", "SimpleNumber", "NumberLiteralExpression", "OrExpression", "binary expressions", "runtime", "tutorial", "example"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};